/* ============================================================
   9Marks — Fade slideshow
   Converts the native (swipe/scroll) hero slideshow to a cross-fade.
   Neutralizes the native scroll-based controller and drives the
   slides with opacity + an independent autoplay/controls.
   ============================================================ */
(function () {
  function initFade(show) {
    var comp = show.closest('slideshow-component') || show.parentElement;
    var slides = Array.prototype.slice.call(show.querySelectorAll('.slideshow__slide'));
    if (slides.length < 2) return;

    var dots = comp ? comp.querySelectorAll('.slider-counter__link') : [];
    var prev = comp ? comp.querySelector('button[name="previous"], .slider-button--prev') : null;
    var next = comp ? comp.querySelector('button[name="next"], .slider-button--next') : null;
    var pauseBtn = comp ? comp.querySelector('.slideshow__autoplay') : null;

    var SPEED = 5000;
    var index = 0;
    var prev = -1;
    var timer = null;
    var playing = true;

    // Fully neutralize the native scroll controller so it can't fight us.
    if (comp) {
      try { if (typeof comp.pause === 'function') comp.pause(); } catch (e) {}
      comp.play = function () {};
      comp.pause = function () {};
      comp.autoRotateSlides = function () {};
      comp.setSlidePosition = function () {};
    }

    // Apply the fade layout + initial state up front so the visual cross-fade
    // works even if binding an optional control below ever fails.
    show.classList.add('slideshow--fade');
    render();
    start();

    function render() {
      slides.forEach(function (s, i) {
        var active = i === index;
        // The outgoing slide stays fully opaque beneath the incoming one
        // (is-prev-fade) so the white background never shows through.
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
        s.classList.toggle('is-active-fade', active);
        s.classList.toggle('is-prev-fade', i === prev && !active);
        s.querySelectorAll('a').forEach(function (a) {
          if (active) a.removeAttribute('tabindex');
          else a.setAttribute('tabindex', '-1');
        });
      });
      if (dots && dots.length) {
        Array.prototype.forEach.call(dots, function (d, i) {
          var active = i === index;
          d.classList.toggle('slider-counter__link--active', active);
          if (active) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
      }
    }

    function go(n) {
      var next = (n + slides.length) % slides.length;
      if (next === index) return;
      prev = index;
      index = next;
      render();
    }

    function start() {
      stop();
      if (!playing) return;
      timer = setInterval(function () { go(index + 1); }, SPEED);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    function bind(el, fn) {
      if (!el || typeof el.addEventListener !== 'function') return;
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        fn();
        if (playing) start();
      }, true);
    }

    bind(next, function () { go(index + 1); });
    bind(prev, function () { go(index - 1); });
    if (dots && dots.length) {
      Array.prototype.forEach.call(dots, function (d, i) {
        bind(d, function () { go(i); });
      });
    }
    if (pauseBtn) {
      pauseBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        playing = !playing;
        pauseBtn.classList.toggle('slideshow__autoplay--paused', !playing);
        if (playing) start(); else stop();
      }, true);
    }

    // Pause on hover for usability
    show.addEventListener('mouseenter', stop);
    show.addEventListener('mouseleave', function () { if (playing) start(); });
  }

  function run() {
    document.querySelectorAll('.slideshow.banner').forEach(initFade);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
